<template>
  <v-alert
    v-if="!orderTotalAmountValidStore(storeId)"
    :border="border"
    :color="color"
    :colored-border="coloredBorder"
    :dense="dense"
    :text="text"
    class="mb-0 text-body-2 fill-width"
    v-bind="$attrs"
    v-on="$listeners"
  >
    {{ $t(`Cart.Message.Info.MinimumOrder.${sortText ? 'BodyAlt' : 'Body'}`, {minimumOrderTotalDiff: $options.filters.currency(orderMinTotalAmountDiffStore(storeId))}) }}
  </v-alert>
</template>

<script>

import CartStoreMinimumOrderWarningMixin from '@/theme/default/components/cart/CartStoreMinimumOrderWarning.js'

export default {
  name  : 'CartStoreMinimumOrderWarning',
  mixins: [CartStoreMinimumOrderWarningMixin]
}
</script>

<style scoped src="@/theme/default/components/cart/CartStoreMinimumOrderWarning.css"></style>

<style scoped>
</style>
